<div *ngIf="posts | async as posts; else loading" class="posts">
  <app-post *ngFor="let post of posts" [post]="post"></app-post>
</div>

<ng-template #loading>
  <div class="loader"></div>
</ng-template>
